import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMOSearchAdminUserView from 'components/dashboard/owners/settings/SMOSearchAdminUserView';

class SMOSettingEditAdminFragmentView extends SMDashboardBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      owner: this.props.owner, 
      isCurrent : this.props.isCurrent,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : nextProps.isCurrent,
      owner : nextProps.owner,
    });
  }
  
  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);
        
    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }
  
  addAdminUserDidSelect(e) {
    e.preventDefault();
    this.showDialog(<SMOSearchAdminUserView owner={this.props.owner} delegate={this} />);
  }
  
  saveFormDidSubmit(e) {
    e.preventDefault();
    this.props.delegate.saveFormDidSubmit(e.currentTarget);
  }
  
  addAdminFormDidSubmit(user) {
    this.setState(function(previousState, currentProps) {
      previousState.owner.owners_users.push({user_id: user.id, user: user});
      return {owner: previousState.owner};
    });
  }
  
  handleDeleteItem(e) {
    e.preventDefault();
    let index = parseInt($(e.currentTarget).data('index'));
        
    this.setState(function(previousState, currentProps) {
      previousState.owner.owners_users[index]._destroy = 1;
      return {
        owner: previousState.owner
      };
    });
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>管理ホスト<br />
          <span className="dashboard-title__supplement">
            既存のアカウントを、スペースの登録、メッセージへの返信や予約の承認などの権限を持つ管理者として追加・削除することができます。
          </span>
        </h2>
        
        <form onSubmit={this.saveFormDidSubmit.bind(this)}>
          <div>
            {this.state.owner.owners_users.map(function(item, index, array){
              if (item.user && item.user.is_spacemarket) return null;
              if (item._destroy == 1) {
                return([
                  <input type='hidden' key={item.id + '-id'} name={'owners_users['+index+'][id]'} value={item.id} />,
                  <input type='hidden' key={item.id + '-user_id'} name={'owners_users['+index+'][user_id]'} value={item.user_id} />,
                  <input type='hidden' key={item.id + '-_destroy'} name={'owners_users['+index+'][_destroy]'} value={1} />
                ]);
              } else {
                return(
                  <div key={item.id + '-' + index} className="form-casette form-user-box">
                    <input type='hidden' name={'owners_users['+index+'][id]'} value={item.id} />
                    <input type='hidden' name={'owners_users['+index+'][user_id]'} value={item.user_id} />
                    <input type='hidden' name={'owners_users['+index+'][_destroy]'} value={0} />
                    {SMAppHelper.userIsDeleted(item.user) ?
                      <img src={SMFormatHelper.defaultIcon()} alt="" className="form-user-box__img" /> :
                      <a href={Routes.user_path(item.user.username)}><img src={item.user.profile_image} alt="" className="form-user-box__img" /></a>}
                    <p className="form-user-box__name">
                      {SMAppHelper.userIsDeleted(item.user) ? item.user.name :
                        <a href={Routes.user_path(item.user.username)}>{item.user.name}</a>}
                    </p>
                    <a href="#" data-index={index} onClick={this.handleDeleteItem.bind(this)} className="form-casette__close form-user-box__close"><i className="fa fa-trash-o"></i></a>
                  </div>
                );
              }
              
            }, this)}
          </div>

          <div className="form-box">
            <a href="#" onClick={this.addAdminUserDidSelect.bind(this)} className="button-gray form-img-button">
              <i className="fa fa-plus"></i> ホストを追加
            </a>
          </div>
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}

SMOSettingEditAdminFragmentView.propTypes = {
  owner: PropTypes.object.isRequired,
  delegate: PropTypes.object,
  errors: PropTypes.array,
};
export default SMOSettingEditAdminFragmentView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingEditAdminFragmentView.jsx